import React from 'react';

const NoContents = (
    <svg width='250' height='137' viewBox='0 0 250 137' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M63 121.5H154C154.515 121.5 155.017 121.444 155.5 121.339C155.983 121.444 156.485 121.5 157 121.5H209C212.866 121.5 216 118.366 216 114.5C216 110.634 212.866 107.5 209 107.5H203C199.134 107.5 196 104.366 196 100.5C196 96.634 199.134 93.5 203 93.5H222C225.866 93.5 229 90.366 229 86.5C229 82.634 225.866 79.5 222 79.5H200C203.866 79.5 207 76.366 207 72.5C207 68.634 203.866 65.5 200 65.5H136C139.866 65.5 143 62.366 143 58.5C143 54.634 139.866 51.5 136 51.5H79C75.134 51.5 72 54.634 72 58.5C72 62.366 75.134 65.5 79 65.5H39C35.134 65.5 32 68.634 32 72.5C32 76.366 35.134 79.5 39 79.5H64C67.866 79.5 71 82.634 71 86.5C71 90.366 67.866 93.5 64 93.5H24C20.134 93.5 17 96.634 17 100.5C17 104.366 20.134 107.5 24 107.5H63C59.134 107.5 56 110.634 56 114.5C56 118.366 59.134 121.5 63 121.5ZM226 121.5C229.866 121.5 233 118.366 233 114.5C233 110.634 229.866 107.5 226 107.5C222.134 107.5 219 110.634 219 114.5C219 118.366 222.134 121.5 226 121.5Z'
            fill='#D3D2D7'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M113.119 99.8066C113.04 100.36 113 100.925 113 101.5C113 108.127 118.373 113.5 125 113.5C131.627 113.5 137 108.127 137 101.5C137 100.925 136.96 100.36 136.881 99.8066H166V126.5C166 128.157 164.657 129.5 163 129.5H87C85.3431 129.5 84 128.157 84 126.5V99.8066H113.119Z'
            fill='white'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M138 99.5C138 106.68 132.18 112.5 125 112.5C117.82 112.5 112 106.68 112 99.5C112 99.2674 112.006 99.0362 112.018 98.8066H84L93.5604 70.5389C93.9726 69.3202 95.1159 68.5 96.4023 68.5H153.598C154.884 68.5 156.027 69.3202 156.44 70.5389L166 98.8066H137.982C137.994 99.0362 138 99.2674 138 99.5Z'
            fill='white'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M136.098 100.455C136.098 106.002 131.129 111.5 125 111.5C118.871 111.5 113.902 106.002 113.902 100.455C113.902 100.275 113.908 99.0962 113.918 98.9188H93L101.161 79.0755C101.513 78.1338 102.489 77.5 103.587 77.5H146.413C147.511 77.5 148.487 78.1338 148.839 79.0755L157 98.9188H136.082C136.092 99.0962 136.098 100.275 136.098 100.455Z'
            fill='#E2E1E5'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M85.25 99.0123V125.5C85.25 126.466 86.0335 127.25 87 127.25H163C163.966 127.25 164.75 126.466 164.75 125.5V99.0123L155.255 70.9393C155.015 70.2285 154.348 69.75 153.598 69.75H96.4023C95.6519 69.75 94.985 70.2285 94.7446 70.9393L85.25 99.0123Z'
            stroke='#9D9BA7'
            strokeWidth='2.5'
        />
        <path
            d='M98.0005 98.5C101.937 98.5 106.185 98.5 110.745 98.5C112.622 98.5 112.622 99.8186 112.622 100.5C112.622 107.127 118.118 112.5 124.898 112.5C131.678 112.5 137.174 107.127 137.174 100.5C137.174 99.8186 137.174 98.5 139.05 98.5H164M90.5742 98.5H93.0005H90.5742Z'
            stroke='#9D9BA7'
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M150.1 45.8027L139 58.2559M124.1 41.5V58.2559V41.5ZM98 45.8027L109.1 58.2559L98 45.8027Z'
            stroke='#9D9BA7'
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default NoContents;
